import { FirstName } from '@dreryk/person-name-common-api';

import { FormContextValues, Validate } from '@dreryk/react-common';
import { FirstNameInput } from '@dreryk/react-components';

const FIRST_NAME_FIELD_NAME = 'firstName';

export type FirstNameFormBeanPart = { [FIRST_NAME_FIELD_NAME]: FirstName | null };

type FirstNameFieldProps = Pick<FormContextValues<FirstNameFormBeanPart>, 'register'> & {
   readonly onValidate: Validate;
};

export const FirstNameField = (props: FirstNameFieldProps): JSX.Element => {
   return (
      <FirstNameInput
         controller={props.register(FIRST_NAME_FIELD_NAME, {
            maxLength: FirstName.MAX_LENGTH,
            validate: props.onValidate,
         })}
         testId={FIRST_NAME_FIELD_NAME}
      />
   );
};
